import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IReservationSectionPackage } from 'src/app/shared/services/reservation.service';
import { IStore } from '../../services/store.service';
import { IProvinceTax } from '../../services/tax.service';

export interface IReservationCheckoutTotalOptions {
  taxes: IProvinceTax[];
  tip: number;
  subTotal: number;
  convenienceFee:number;
}

@Component({
    selector: 'reservation-checkout-total',
    templateUrl: './reservation-checkout-total.component.html',
    styleUrls: ['./reservation-checkout-total.component.scss'],
    standalone: false
})
export class ReservationCheckoutTotalComponent implements OnInit {
  total: number;
  taxesTotal: number[] = [];
  _options: IReservationCheckoutTotalOptions;
  _reservationSectionPackages: IReservationSectionPackage[];
  
  @Output() onTotal : EventEmitter<number> = new EventEmitter<number>();
  @Input() 
  set options(options: IReservationCheckoutTotalOptions) {
    this._options = options;
    this.calculateTotal();
  }

  @Input()
  set reservationSectionPackages(reservationSectionPackages: IReservationSectionPackage[]){
    this._reservationSectionPackages = reservationSectionPackages;
  }

  get options() {
    return this._options;
  }

  constructor() { }

  ngOnInit() {

  }

  private calculateTotal() {
    let total: number = 0;
    this.taxesTotal = [];

    //Remove all the non-taxable item from the subtotal to do the tax calculation
    let nonTaxableAmount = this.getNonTaxableTotal();
    let subTotal = this.options.subTotal + this.options.convenienceFee;    
    subTotal -= nonTaxableAmount;

    let tempSubTotal = subTotal;
    for (let tax of this.options.taxes) {
      subTotal = tempSubTotal;     
      const taxTotal = (subTotal) * (tax.rate / 100);
      total += taxTotal;
      this.taxesTotal.push(taxTotal);
    }

    total += this.options.convenienceFee;    
    total += this.options.subTotal;
    total += this.options.tip;
    this.total = total;
    this.onTotal.emit(this.total);
  }

  private getNonTaxableTotal() {
    let amount = 0;

    if (this._reservationSectionPackages) {
      for (let i = 0; i < this._reservationSectionPackages.length; i++) {
        if (!this._reservationSectionPackages[i].TaxEligible) {
            amount += this._reservationSectionPackages[i].Price * this._reservationSectionPackages[i].Quantity;
        }
      }
    }
   
    return amount;
  }
}
